import { Attachment, ReportingItem } from "product-test-types";

import { STRAPI_URL } from "../env";

export async function fetchAttachmentsByReportingItem(
  reportingItemId: string
): Promise<Attachment[]> {
  try {
    const response = await fetch(
      `${STRAPI_URL}/attachments/reporting-item/${reportingItemId}`,
      {
        credentials: "include",
      }
    );
    if (response.ok) {
      return await response.json();
    }
    return [];
  } catch (error) {
    console.error("Failed to load attachments:", error);
    return [];
  }
}

export async function uploadAttachment(
  reportingItemId: string,
  file: File
): Promise<Attachment | null> {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await fetch(
      `${STRAPI_URL}/attachments/upload/${reportingItemId}`,
      {
        method: "POST",
        body: formData,
        credentials: "include",
      }
    );

    if (response.ok) {
      return await response.json();
    }
    return null;
  } catch (error) {
    console.error("Upload failed:", error);
    return null;
  }
}

export async function deleteAttachment(id: string): Promise<boolean> {
  try {
    const response = await fetch(`${STRAPI_URL}/attachments/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    return response.ok;
  } catch (error) {
    console.error("Delete failed:", error);
    return false;
  }
}

export async function downloadAttachment(id: string): Promise<void> {
  try {
    const response = await fetch(`${STRAPI_URL}/attachments/${id}/download`, {
      credentials: "include",
    });
    if (response.ok) {
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  } catch (error) {
    console.error("Download failed:", error);
  }
}

export async function confirmTemporaryAttachments(
  reportingItems: ReportingItem[]
): Promise<boolean> {
  try {
    const response = await fetch(`${STRAPI_URL}/attachments/confirm`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({ reportingItems }),
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.ok;
  } catch (error) {
    console.error("Confirm attachments failed:", error);
    return false;
  }
}

export async function removeTemporaryAttachments(
  reportingItemId: string
): Promise<boolean> {
  try {
    const response = await fetch(
      `${STRAPI_URL}/attachments/temporary/${reportingItemId}`,
      {
        method: "DELETE",
        credentials: "include",
      }
    );
    return response.ok;
  } catch (error) {
    console.error("Remove temporary attachments failed:", error);
    return false;
  }
}
